/*!

=========================================================
* Light Bootstrap Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import NotificationSystem from "react-notification-system";

import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.jsx";

import { style } from "variables/Variables.jsx";

import routes from "routes.js";

import image from "assets/img/sidebar-3.jpg";
import firebase from 'firebase';

class Admin extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount.bind(this)
    this.state = {
      _notificationSystem: null,
      image: image,
      color: "black",
      hasImage: true,
      fixedClasses: "dropdown show-dropdown open",
      mensagens:[],
      numero:0,
      inicio:0,
      inicioprofissionais:0,
      iniciosindicos:0,
      iniciopedidos:0,
      profissionais:[],
      sindicos:[],
      pedidos:[]
  
    };
  }
 
  handleNotificationClick = (position,mensagem,icone) => {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className={icone} />,
      message: (
        <div>
         {mensagem}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15
    });
  };
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            render={props => (
              <prop.component
                {...props}
                handleClick={this.handleNotificationClick}
                mensagens={this.state.mensagens}
                pedidos={this.state.pedidos}
                profissionais={this.state.profissionais}
                sindicos={this.state.sindicos}
              />
            )}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  handleImageClick = image => {
    this.setState({ image: image });
  };
  handleColorClick = color => {
    this.setState({ color: color });
  };
  handleHasImage = hasImage => {
    this.setState({ hasImage: hasImage });
  };
  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this.setState({ fixedClasses: "dropdown show-dropdown open" });
    } else {
      this.setState({ fixedClasses: "dropdown" });
    }
  };
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var _notificationSystem = this.refs.notificationSystem;
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    _notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-like2" />,
      message: (
        <div>
          Bem vindo! <b>Painel web SJC</b> - Aqui você terá os pedidos,cadastros e mensagens dos clientes do aplicativo em tempo real!
        </div>
      ),
      level: level,
      position: "tr",
      autoDismiss: 15
    });
    firebase.database().ref('/recados').on('value',(snapshot)=>{
      try{
        let mensagensarray = snapshot.val()
        console.log('FIREBASE VAL',mensagensarray)
        let arraydemensagens = []
        let numero = Object.keys(mensagensarray).length
        console.log('fes o snapshot')
        for (const key in mensagensarray) {
          if (mensagensarray.hasOwnProperty(key)) {
            
            console.log('NO ARRAY DE MENSAGENS')
            const mensagem = mensagensarray[key];
            let novamensagem = [numero]
            if(mensagem.hasOwnProperty('nome')) {novamensagem = [...novamensagem,mensagem.nome]}
            else{novamensagem = [...novamensagem,'teste']}
            if(mensagem.hasOwnProperty('recado')){ novamensagem = [...novamensagem,mensagem.recado]}
            else{novamensagem = [...novamensagem,'teste recado']}
            if(mensagem.hasOwnProperty('data')) {novamensagem = [...novamensagem,mensagem.data]}
            else{novamensagem = [...novamensagem,'data']}
            arraydemensagens.push(novamensagem)
            numero--
  
            
          }
        }
        this.setState({mensagens:arraydemensagens.reverse(),inicio:this.state.inicio+1})
      }catch(e){
        console.log("SEM MENSAGENS")
      }
      
    })
    firebase.database().ref('/profissionais').on('value',(snapshot)=>{
      try{
        let profissionaisfire = snapshot.val()
      console.log('FIREBASE VAL',profissionaisfire)
      let profissionaisarray = []
      let numero = Object.keys(profissionaisfire).length
      console.log('fes o snapshot')
      for (const key in profissionaisfire) {
        if (profissionaisfire.hasOwnProperty(key)) {
          
          console.log('NO ARRAY DE MENSAGENS')
          const profissional = profissionaisfire[key];
          let profissionalnovo = [numero,
          profissional.celularDDD,
          profissional.cidadeEmpresa,
          profissional.cnpjoucpf,
          profissional.emailParticular,
          profissional.enderecoCompleto,
          profissional.horarioAtendimento,
          profissional.inscricaoEstadual,
          profissional.inscricaoMunicipal,
          profissional.nomeFantasia,
          profissional.possuiFuncionarios,
          profissional.razaoSocial,
          profissional.referenciaDeClientes,
          profissional.telefoneFixo,
          profissional.tiposServicoExecuta,
          profissional.fotos,
          profissional.fotosrgecpf
          ]
          
          profissionaisarray.push(profissionalnovo)
          numero--

          
        }
      }
      console.log(profissionaisarray)
      this.setState({profissionais:profissionaisarray.reverse(),inicioprofissionais:this.state.inicioprofissionais+1})
        
      }catch(e){
        console.log('SEM PROFISSIONAIS')
      }
      
    })
    firebase.database().ref('/sindicos').on('value',(snapshot)=>{
      try{
        let profissionaisfire = snapshot.val()
      console.log('FIREBASE VAL',profissionaisfire)
      let profissionaisarray = []
      let numero = Object.keys(profissionaisfire).length
      console.log('fes o snapshot')
      for (const key in profissionaisfire) {
        if (profissionaisfire.hasOwnProperty(key)) {
          
          console.log('NO ARRAY DE MENSAGENS')
          const profissional = profissionaisfire[key];
          let profissionalnovo = [numero,
          profissional.celularDDD,
          profissional.nomeCompleto,
          profissional.nomeDoPredioMora,
          profissional.enderecoCOmpleto,
          profissional.bloco,
          profissional.apto,
          
          ]
          
          profissionaisarray.push(profissionalnovo)
          numero--

          
        }
      }
      console.log('Sindicos',profissionaisarray)
      this.setState({sindicos:profissionaisarray.reverse(),iniciosindicos:this.state.iniciosindicos+1})

      }catch(e){
        console.log('SEM SINDICOS');
      }
      
    })
    firebase.database().ref('/pedidos').on('value',(snapshot)=>{
      try{
        let profissionaisfire = snapshot.val()
        console.log('FIREBASE VAL',profissionaisfire)
        let profissionaisarray = []      
        if(profissionaisfire !== null){
          let numero = Object.keys(profissionaisfire).length
          console.log('fes o snapshot')
          for (const key in profissionaisfire) {
            if (profissionaisfire.hasOwnProperty(key)) {
              
              console.log('NO ARRAY DE MENSAGENS')
              const profissional = profissionaisfire[key];
              let profissionalnovo = [numero,
              profissional.email,
              profissional.nome,
              profissional.celular,
              profissional.endereco,
              profissional.telefone,
              profissional.nomedopredio,
              profissional.bloco,
              profissional.apto,
              profissional.nomesindico,
              profissional.nomedocomercio,
              profissional.nomedaescola,
              profissional.nomedaempresa,
              profissional['areadeatuação'],
              profissional.fotos]
              
              profissionaisarray.push(profissionalnovo)
              numero--
            }
          }
          console.log('pedidos',profissionaisarray)
          this.setState({pedidos:profissionaisarray.reverse(),iniciopedidos:this.state.iniciopedidos+1});
        }
        
      }catch(e){
        console.log("SEM PEDIDOS");
      }
      
    })
  
    firebase.database().ref('/recados').on('child_added',(snapshot)=>{
      let novamensagem = snapshot.val()
      let mensagem = 'Nova mensagem de '
      if(novamensagem.hasOwnProperty('nome')) mensagem+= ` ${novamensagem.nome}`
      if(novamensagem.hasOwnProperty('recado')) mensagem += ` Mensagem: ${novamensagem.recado.substr(0,8)}...`
      if(this.state.inicio === 0) return

      this.handleNotificationClick('tr',mensagem,'pe-7s-mail')
    })
    firebase.database().ref('/pedidos').on('child_added',(snapshot)=>{
      let novamensagem = snapshot.val()
      let mensagem = 'Nova Pedido Adicionado! '
      
      if(this.state.iniciopedidos === 0) return

      this.handleNotificationClick('tr',mensagem,'pe-7s-bell')
    })
    firebase.database().ref('/sindicos').on('child_added',(snapshot)=>{
      let novamensagem = snapshot.val()
      let mensagem = 'Novo Sindico Cadastrado! '
      
      if(this.state.iniciosindicos === 0) return

      this.handleNotificationClick('tr',mensagem,'pe-7s-user')
    })
    firebase.database().ref('/profissionais').on('child_added',(snapshot)=>{
      let novamensagem = snapshot.val()
      let mensagem = 'Novo Profissional Cadastrado! '
      
      if(this.state.inicioprofissionais === 0) return

      this.handleNotificationClick('tr',mensagem,'pe-7s-id')
    })
  }
  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  render() {
    return (
      <div className="wrapper">
        <NotificationSystem ref="notificationSystem" style={style} />
        <Sidebar {...this.props} routes={routes} image={this.state.image}
        color={this.state.color}
        hasImage={this.state.hasImage}/>
        <div id="main-panel" className="main-panel" ref="mainPanel">
          <AdminNavbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
          />
          <Switch>{this.getRoutes(routes)}</Switch>
          <Footer />
          {
            /**
            <FixedPlugin
            handleImageClick={this.handleImageClick}
            handleColorClick={this.handleColorClick}
            handleHasImage={this.handleHasImage}
            bgColor={this.state["color"]}
            bgImage={this.state["image"]}
            mini={this.state["mini"]}
            handleFixedClick={this.handleFixedClick}
            fixedClasses={this.state.fixedClasses}
          />
             */
          }
          
        </div>
      </div>
    );
  }
}

export default Admin;
